import { Link } from 'react-router-dom';
import { servicesList } from '@/mocks/services';

export default function ServicesSection() {
  return (
    <section className="bg-[#f5f0e8] py-20 md:py-28" id="hizmetler">
      <div className="max-w-7xl mx-auto px-6 md:px-10">

        {/* Header */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-end mb-14">
          <div>
            <p className="font-body text-[#d4a853] text-xs font-semibold tracking-[0.25em] uppercase mb-4">— Çözümlerimiz</p>
            <h2 className="font-heading text-4xl md:text-5xl text-[#0f1923] leading-tight">
              İzmir&apos;de Tente <br />ve Pergola Sistemleri
            </h2>
          </div>
          <div className="flex flex-col gap-4 md:items-end">
            <p className="font-body text-[#6b7280] text-sm leading-relaxed max-w-sm md:text-right">
              11 farklı sistem, her alana özel çözüm. Konut, ticari ve otel projelerinde ücretsiz keşif.
            </p>
            <Link
              to="/hizmetler"
              className="inline-flex items-center gap-2 font-body text-sm font-semibold text-[#0f1923] border-b border-[#0f1923]/30 hover:border-[#d4a853] hover:text-[#d4a853] transition-all pb-0.5 whitespace-nowrap"
            >
              Tüm Hizmetleri Gör <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {servicesList.map((service, idx) => (
            <Link
              key={service.slug}
              to={`/hizmetler/${service.slug}`}
              className="group relative bg-white rounded-xl overflow-hidden cursor-pointer hover:-translate-y-1 transition-all duration-300"
            >
              <div className="h-44 overflow-hidden">
                <img
                  src={service.image}
                  alt={`${service.title} İzmir`}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0f1923]/80 via-[#0f1923]/20 to-transparent"></div>
              </div>

              {/* Number badge */}
              <div className="absolute top-3 right-3 w-7 h-7 flex items-center justify-center bg-[#d4a853] rounded-full">
                <span className="font-body text-[#0f1923] text-xs font-bold">{String(idx + 1).padStart(2, '0')}</span>
              </div>

              {/* Content overlay */}
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <h3 className="font-heading text-base text-white leading-tight mb-1">{service.title}</h3>
                <span className="font-body text-[#d4a853] text-xs flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                  İncele <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-12 flex flex-col sm:flex-row items-center justify-between gap-6 bg-[#0f1923] rounded-2xl px-8 py-6">
          <div>
            <p className="font-heading text-xl text-white">Hangi sistem size uygun?</p>
            <p className="font-body text-white/50 text-sm mt-1">Uzman ekibimiz yerinde değerlendirsin.</p>
          </div>
          <div className="flex gap-3">
            <a href="tel:05362771709" className="inline-flex items-center gap-2 bg-[#d4a853] text-[#0f1923] font-body font-semibold text-sm px-6 py-3 rounded-lg hover:bg-[#e8c47a] transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-phone-fill"></i>Ücretsiz Keşif
            </a>
            <a href="https://wa.me/905362771709" target="_blank" rel="noopener noreferrer nofollow" className="inline-flex items-center gap-2 border border-white/20 text-white font-body font-medium text-sm px-6 py-3 rounded-lg hover:border-[#d4a853] hover:text-[#d4a853] transition-all cursor-pointer whitespace-nowrap">
              <i className="ri-whatsapp-fill"></i>WhatsApp
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
